import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AppBar } from './AppBar';

/**
 * Full-viewport layout for the Measurement Analysis page.
 * Constrains content to exactly the viewport height with no outer scroll,
 * leaving page-level content to manage its own internal scroll/overflow.
 */
export function AnalysisLayout() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      <AppBar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          width: '100vw',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 1600,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
            overflow: 'hidden',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
